import type { Option } from 'components/CollapsibleOptionPicker';
import CollapsibleOptionPicker from 'components/CollapsibleOptionPicker';
import React, { Component } from 'react';
import { ActivityFilterType, ActivityFilterTypeText } from 'redux/modules/activities.types';
import { safeInvoke } from 'utils/safeInvoke';

interface SelectionOption extends Option {
  value: ActivityFilterType;
  isLockedFeature?: boolean;
}

interface ActivitiesFilterDropdownProps {
  status: ActivityFilterType;
  isAnomaliesLocked?: boolean;

  onChange: (status: ActivityFilterType) => void;
  onLockedAnomaliesFeatureClicked: () => void;
}

class ActivitiesFilterDropdown extends Component<ActivitiesFilterDropdownProps> {
  handleOnChange = (option: SelectionOption) => {
    if (option.value === ActivityFilterType.Anomalies && this.props.isAnomaliesLocked) {
      safeInvoke(this.props.onLockedAnomaliesFeatureClicked);
    } else {
      safeInvoke(this.props.onChange, option.value);
    }
  };

  render() {
    const options: Array<SelectionOption> = Object.entries(ActivityFilterType).map(
      ([activityKey, activityFilterType]) => {
        return {
          value: activityFilterType,
          name: ActivityFilterTypeText[activityKey as keyof typeof ActivityFilterType],
          active: this.props.status === activityFilterType,
          isLockedFeature:
            this.props.isAnomaliesLocked && activityKey === ActivityFilterType.Anomalies,
        };
      }
    );

    return (
      <CollapsibleOptionPicker
        testIdScope="calendar_header"
        position="bottom-start"
        isCollapsed={false}
        options={options}
        onClick={this.handleOnChange}
        size="small"
      />
    );
  }
}

export default ActivitiesFilterDropdown;
